<!-- TrustBox widget - Starter -->
<div id="trustpilot-box" class="trustpilot-widget" data-locale="en-US" data-template-id="5613c9cde69ddc09340c6beb"
  data-businessunit-id="5724a8c80000ff00058c3a8a" data-style-height="100%" data-style-width="100%" data-theme="light">
  <a href="https://www.trustpilot.com/review/irishcelticjewellery.com" target="_blank" rel="noopener">Trustpilot</a>
</div>
<!-- End TrustBox widget -->